import ApiPackageConsultationModal from '@/components/modals/ApiPackageConsultationModal'

export const GlobalModals = () => (
  <>
    <ApiPackageConsultationModal />
  </>
)

export default GlobalModals
